import { Injectable } from '@angular/core';
import {
  SEARCH_REQUEST,
  TRIP_DETIALS_URL
} from '../constants/my-trip-constants';
import { SearchRequest } from '../models/interface';

@Injectable({
  providedIn: 'root'
})
export class SearchFacade {
  findTrip(request: SearchRequest): void {
    sessionStorage.setItem(SEARCH_REQUEST, JSON.stringify(request));
    window.location.href = TRIP_DETIALS_URL;
  }
}
